import React from 'react';
import { Grid, Typography, useTheme } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EventIcon from '@mui/icons-material/Event';
import HotelIcon from '@mui/icons-material/Hotel';

import RestaurantIcon from '@mui/icons-material/Restaurant';

import PluralizeRoomDetails from '../helpers/PluralizeRoomDetails';
import { formatDateOnlyNumbers } from '@shared/helpers/formatDate';
import { sxStyle } from './styles';

const BookingBasicInfo = ({ hotelDetails, room, searchData }) => {
  const theme = useTheme();

  return (
    <Grid container direction="column">
      <Typography sx={sxStyle.textWithIcons}>
        <LocationOnIcon sx={sxStyle.icon} />
        {hotelDetails.location.address}
      </Typography>

      <Typography sx={sxStyle.textWithIcons}>
        <EventIcon sx={sxStyle.icon} />
        {formatDateOnlyNumbers(searchData.checkIn)} -{' '}
        {formatDateOnlyNumbers(searchData.checkOut)}
      </Typography>

      <Typography sx={sxStyle.textWithIcons}>
        <HotelIcon sx={sxStyle.icon} />
        <span>
          <PluralizeRoomDetails
            room={room}
            totalPassengers={searchData.totalPassengers}
            totalNights={searchData.totalNights}
          />
        </span>
      </Typography>

      <Typography sx={sxStyle.textWithIcons}>
        <RestaurantIcon sx={sxStyle.icon} />
        <Typography
          component="span"
          sx={{
            color: theme.tertiary,
            fontWeight: 600,
            fontSize: '15px',
          }}
        >
          {room?.board?.description}
        </Typography>
      </Typography>
    </Grid>
  );
};

export default BookingBasicInfo;
